export default __webpack_public_path__ + "static/recog-6-db320b9f5197106df1f85f1f1e3cd32f.webp";